import React from "react";
import RadialGradient from "../additionalDesign/radialGradient";
import DmeTechInfo from "../dmeTechInfo/dmeTechInfo";
import Faq from "../faq/faq";
import News from "../news/news";
import Pricing from "../pricing/pricing";
import RemappingDataBase from "../remappingDataBase/remappingDataBase";
import Tutorials from "../tutorials/tutorials";

const HomePage: React.FC = () => {
  return (
    <>
      <DmeTechInfo />
      <RemappingDataBase />
      <RadialGradient />

      <Tutorials />
      <Pricing />
      <RadialGradient />
      <News />
      <Faq />
    </>
  );
};

export default HomePage;
